<template>
  <aside class="col-lg-3">
    <div class="card p-4">
      <div class="sidebar">
        <div v-if="category == 4 && permission" class="mb-3">
          <router-link to="/presentation/create" class="btn btn-primary" style="width: 100%">Nuova
            presentazione</router-link>
        </div>
        <div v-else-if="category == 2 && permission" class="mb-3">
          <router-link to="/library/create" class="btn btn-primary w-100">Aggiungi articolo</router-link>
        </div>
        <div class="widget widget-collapsible mb-4 mb-md-0">
          <h3 class="widget-title">
            <a data-toggle="collapse" href="#sidebar-collapse " role="button" aria-expanded="true"
              aria-controls="sidebar-collapse">
              Cerca
            </a>
          </h3>
          <div class="collapse show" id="sidebar-collapse">
            <div class="widget-body">
              <div class="widget widget-search">
                <!-- End .widget-title -->

                <form>
                  <label for="ws" class="sr-only">Cerca fra i casi</label>
                  <input type="search" class="form-control" name="q" id="ws" :placeholder="placeholderSearch"
                    v-model="textSearch" @input="search" />
                  <button type="button" class="btn">
                    <i class="icon-search"></i><span class="sr-only">Cerca</span>
                  </button>
                </form>
              </div>
              <!-- End .widget -->

              <form id="neurohub-filter">
                <div class="widget widget-collapsible" v-if="category != 4 && category != 2">
                  <h3 class="widget-title">
                    <a data-toggle="collapse" href="#widget-1" role="button" aria-expanded="true"
                      aria-controls="widget-1">
                      Tipologia Caso
                    </a>
                  </h3>
                  <!-- End .widget-title -->

                  <div class="collapse" id="widget-1">
                    <div class="widget-body">
                      <div class="filter-items">
                        <div class="filter-item">
                          <div class="custom-control custom-checkbox" v-for="categoryMedical in categoryMedicals"
                            :key="categoryMedical">
                            <input type="checkbox" class="custom-control-input color-search"
                              :id="'category-medical-' + categoryMedical.slug" :value="categoryMedical.id"
                              name="patologie[]" v-model="selectedCategoryMedicals" @change="updateCategoryMedicals"
                              :checked="selectedCategoryMedicals.includes(
                                parseInt(categoryMedical.id)
                              )
                                " />
                            <label class="custom-control-label" :for="'category-medical-' + categoryMedical.slug">{{
                              categoryMedical.name }}</label>
                          </div>
                          <!-- End .custom-checkbox -->
                        </div>
                        <!-- End .filter-item -->
                      </div>
                      <!-- End .filter-items -->
                    </div>
                    <!-- End .widget-body -->
                  </div>
                  <!-- End .collapse -->
                </div>
                <!-- End .widget -->

                <div class="widget widget-collapsible">
                  <h3 class="widget-title">
                    <a data-toggle="collapse" href="#widget-2" role="button" aria-expanded="true"
                      aria-controls="widget-2">
                      Distretti anatomici
                    </a>
                  </h3>
                  <!-- End .widget-title -->

                  <div class="collapse" id="widget-2">
                    <div class="widget-body">
                      <div class="filter-items">
                        <div class="filter-item">
                          <div class="custom-control custom-checkbox" v-for="anatomicalDistrict in anatomicalDistricts"
                            :key="anatomicalDistrict">
                            <input type="checkbox" class="custom-control-input color-search"
                              name="distretti_anatomici[]" :id="'anatomical-district-' + anatomicalDistrict.slug
                                " :value="anatomicalDistrict.id" v-model="selectedAnatomicalDistricts"
                              @change="updateAnatomicalDistricts" :checked="selectedAnatomicalDistricts.includes(
                                parseInt(anatomicalDistrict.id)
                              )
                                " />
                            <label class="custom-control-label" :for="'anatomical-district-' + anatomicalDistrict.slug
                              ">{{ anatomicalDistrict.name }}</label>
                          </div>
                          <!-- End .custom-checkbox -->
                        </div>
                        <!-- End .filter-item -->
                      </div>
                      <!-- End .filter-items -->
                    </div>
                    <!-- End .widget-body -->
                  </div>
                  <!-- End .collapse -->
                </div>
                <!-- End .widget -->

                <div class="widget widget-collapsible">
                  <h3 class="widget-title">
                    <a data-toggle="collapse" href="#widget-3" role="button" aria-expanded="true"
                      aria-controls="widget-3">
                      Trattamenti
                    </a>
                  </h3>
                  <!-- End .widget-title -->

                  <div class="collapse" id="widget-3">
                    <div class="widget-body">
                      <div class="filter-items">
                        <div class="filter-item">
                          <div class="custom-control custom-checkbox" v-for="patology in patologies" :key="patology">
                            <input type="checkbox" class="custom-control-input color-search"
                              :id="'feature-patologies-' + patology.slug" :value="patology.id" name="patologie[]"
                              v-model="selectedPatologies" @change="updatePatologies" :checked="selectedPatologies.includes(
                                parseInt(patology.id)
                              )
                                " />
                            <label class="custom-control-label" :for="'feature-patologies-' + patology.slug">{{
                              patology.name }}
                            </label>
                          </div>
                        </div>
                        <!-- End .custom-checkbox -->

                        <!-- End .filter-item -->
                      </div>
                      <!-- End .filter-items -->
                    </div>
                    <!-- End .widget-body -->
                  </div>
                  <!-- End .collapse -->
                </div>
                <!-- End .widget -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End .sidebar -->
  </aside>
</template>
<script>
export default {
  name: "FilterComponent",
  props: [
    "activities",
    "patologies",
    "categoryMedicals",
    "anatomicalDistricts",
    "category",
    "permission",
  ],
  components: {},
  data() {
    return {
      selectedPatologies: [],
      selectedCategoryMedicals: [],
      selectedAnatomicalDistricts: [],
      textSearch: "",
      activitySearch: [],
      placeholderSearch: "",
    };
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.size > 0)
    {
      this.selectedPatologies =
        urlParams.getAll("patologies[]").length > 0
          ? urlParams.getAll("patologies[]")
          : [];
      this.selectedPatologies = this.selectedPatologies.map((patology) =>
        parseInt(patology)
      );

      this.text = urlParams.get("text") != "" > "" ? urlParams.get("text") : [];
      this.selectedCategoryMedicals =
        urlParams.getAll("category_medical[]").length > 0
          ? urlParams.getAll("category_medical[]")
          : [];
      this.selectedCategoryMedicals = this.selectedCategoryMedicals.map(
        (category_medical) => parseInt(category_medical)
      );
      this.selectedAnatomicalDistricts =
        urlParams.getAll("anatomical_district[]").length > 0
          ? urlParams.getAll("anatomical_district[]")
          : [];
      this.selectedAnatomicalDistricts = this.selectedAnatomicalDistricts.map(
        (anatomical_district) => parseInt(anatomical_district)
      );
    }
  },
  created() {
    this.activitySearch = this.activities;
    if (this.category == 4 || this.category == 2)
    {
      this.placeholderSearch = "Cerca per titolo";
    } else
    {
      this.placeholderSearch = "Cerca per titolo o descrizione";
    }
  },
  methods: {
    search() {
      this.$emit("update:filteredText", this.textSearch);
    },
    updatePatologies() {
      console.log("Patologia ");
      console.log(this.selectedPatologies);
      this.$emit("update:filteredPatologies", this.selectedPatologies);
    },
    updateCategoryMedicals() {
      this.$emit(
        "update:filteredCategoryMedicals",
        this.selectedCategoryMedicals
      );
    },
    updateAnatomicalDistricts() {
      this.$emit(
        "update:filteredAnatomicalDistricts",
        this.selectedAnatomicalDistricts
      );
    },
  },
};
</script>